// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"e26b768408a7c9ca62a8","293":"eeb45bbcb20049d9f833","518":"c935a1cab9de55e1ac20","779":"21a925ff1df95bbcb933"}[chunkId] + ".js";
};